import React from 'react';
import GoogleFontLoader from 'react-google-font-loader';
import { withTheme } from 'styled-components';

var FontLoader = function FontLoader(_ref) {
  var _ref$theme$yoga$baseF = _ref.theme.yoga.baseFont,
      family = _ref$theme$yoga$baseF.family,
      weight = _ref$theme$yoga$baseF.weight;
  return /*#__PURE__*/React.createElement(React.Fragment, null, typeof window !== 'undefined' ? /*#__PURE__*/React.createElement(GoogleFontLoader, {
    fonts: [{
      font: family,
      weights: weight
    }]
  }) : /*#__PURE__*/React.createElement("link", {
    rel: "stylesheet",
    href: "https://fonts.googleapis.com/css?family=" + family + ":" + weight.join()
  }));
};

export default withTheme(FontLoader);